<div class="header">
  <h3>{{'MENU.DOCUMENT-NUMBER-SETTING' | translate}}</h3>
</div>

<div class="box-parent">
  <div class="row align-items-center justify-content-between no-gutters">
    <div class="col">
      <h5>{{'MENU.DOCUMENT-NUMBER-SETTING' | translate}}</h5>
    </div>
    <div class="col d-flex justify-content-end">
      <button class="btn btn-dv cancel m-r-10" *ngIf="showCancel" (click)="loadDocumentNumberSetting()">{{'COMMON.CANCEL' | translate}}</button>
      <button class="btn btn-dv" (click)="save()" [disabled]="saving">
        <i *ngIf="saving" class="fa fa-spinner fa-spin"></i>
        {{'TEXT.SAVE' | translate}}
      </button>
    </div>
  </div>
  <div class="m-t-20">
    <div [formGroup]="documentNumberForms">
      <div formArrayName="items">
        <div *ngFor="let formGroup of items.controls; let i = index">
          <div [formGroupName]="i">
            <div class="d-flex align-items-center setting-header">
                <h6 class="m-0 p-y-10 p-l-5">{{getDocumentTypeDisplay(i)}} | {{getPatternDisplay(i)}}</h6>
            </div>
            <div class="row m-b-15">
              <div class="col">
                <label for="prefix">Prefix</label>
                <input id="prefix" type="text" class="form-control" formControlName="prefix"/>
              </div>
              <h5 class="mb-0 m-t-35">-</h5>
              <div class="col">
                <label for="year-pattern">Year</label>
                <ng-select id="year-pattern"
                    [items]="yearPatternChoices"
                    formControlName="yearPattern"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="false">
                </ng-select>
              </div>
              <div class="col">
                <label for="month-pattern">Month</label>
                <ng-select id="month-pattern"
                    [items]="monthPatternChoices"
                    formControlName="monthPattern"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="false">
                </ng-select>
              </div>
              <div class="col">
                <label for="day-pattern">Day</label>
                <ng-select id="day-pattern"
                    [items]="dayPatternChoices"
                    formControlName="dayPattern"
                    bindLabel="label"
                    bindValue="value"
                    [clearable]="false">
                </ng-select>
              </div>
              <h5 class="mb-0 m-t-35">-</h5>
              <div class="col">
                <label for="running-digit">Running Digit(s)</label>
                <input id="running-digit" type="text" class="form-control" formControlName="runningDigit"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #saveResultModal>
  <div class="modal-body m-y-20 text-center">
    <h6 class="m-0">{{resultMessage}}</h6>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dv cancel" (click)="closeModal()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting.component.html